import React from 'react';

import { FormattedMessage, injectIntl } from 'react-intl'
import ScheduleHeaderComponent from './components/Header/ScheduleHeaderComponent';
import TableComponent from './components/TableComponents/TableComponent';
import { SHIFTS_PER_PAGE, } from './constants';
import styledConfirm from '../Requests/components/styled';
import UpgradePrompt from '../../components/GeneralComponents/UpgradePrompt/UpgradePrompt';
import Modal from 'components/GeneralComponents/Modal';

import './ScheduleCalendarComponent.scss';
import 'stylesheets/toast.scss';
import HoursRowComponent from './components/TableComponents/HoursRowComponent';

import './components/TableComponents/TableComponent.scss';

import { startOfLocationFiscalWeek, endOfLocationFiscalWeek } from '../../helpers/date-time';

import 'stylesheets/fonts.scss';
import 'stylesheets/colors.scss';
import 'stylesheets/layout.scss';
import InviteWithEmailContainer from 'pages/UnregisteredUser/InviteWithEmailContainer';
import utils from './duck/utils';
import dataExport from './duck/export';

import './components/TableComponents/ConfirmDeleteAllComponent';
import './components/TableComponents/ConfirmDeleteDraftsComponent';
import ConfirmDeleteAllComponent from './components/TableComponents/ConfirmDeleteAllComponent';
import ConfirmDeleteDraftsComponent from './components/TableComponents/ConfirmDeleteDraftsComponent';

import FinishPastingCopmonent from "./components/Header/FinishPastingComponent";
import ScheduleCalendarRealtimeHandler from './ScheduleCalendarRealtimeHandler';
import { eventTopicName } from 'helpers/mqtt/mqtt-helpers';
import timeUtil from './duck/timeUtil';
import service from './duck/service';
import ShiftTemplatesList from './ShiftTemplates/ShiftTemplatesList';
import Joyride from "react-joyride";
import { customJoyrideStyles, pulseAnimationCSS } from "../../constants/joyrideStyles";

class ScheduleCalendarComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      planName: '',
      showSendEmailModal: false,
      showAddUnregUserModal: false,
      showDeleteEntireScheduleModal: false,
      showDeleteUnpublishedModal: false,
      searchTerm: '',
      selectedDepartment: null,
      selectedGroup: null,
      selectedSkill: null,
      isShowingPastingSnackBar: false,
      shiftBeingPasted: null,
      tooltip: {
        visible: false,
        content: '',
        position: { top: 0, left: 0 }
      },
      toolTipAddTeamMemberRun: false,
      addTeamMemberSteps: [],
      selectedTab: 'schedule',
    };
    this._isMounted = false;
    this.apiCalled = false;
    this.pageIndex = 1;
    this.shouldRunTour = false;
    this.tourTimeout = null; // Add timeout reference

    this.mqttClient = props.mqttClient;
  }

  componentDidMount() {
    const { removeShiftFromReducer, loadSingleShiftDispatch, loadSingleApplicantDispatch, loadSingleFreePostDispatch, loadDepartments, locationId, getScheduleUsers, locationData, plans, loadLocationDataDispatch, loadUnregisteredUsersDispatch, loadLocationRolesDispatch,
       loadLocationSkillsDispatch
      } = this.props;

    loadLocationDataDispatch();
    if (typeof (locationId) !== 'undefined' && locationId !== null) {
      getScheduleUsers(locationId, 1, 10000);
      loadUnregisteredUsersDispatch(locationId);
      loadDepartments(locationId);
      loadLocationRolesDispatch(locationId);
      loadLocationSkillsDispatch(locationId);

      if (this._isMounted == false) {
        this.listenerParams = ScheduleCalendarRealtimeHandler.subscribe(this.mqttClient, loadSingleShiftDispatch, loadSingleApplicantDispatch, loadSingleFreePostDispatch, removeShiftFromReducer);
      }
    }

    if (plans && plans.length > 0) {
      if (locationData && locationData.plan_id) {
        const cplan = plans.find(plan => plan.id === locationData.plan_id);
        this.setState({ planName: cplan.name });
      }
    }

    // const hasSeenAddTeamMemberTour = sessionStorage.getItem("hasSeenAddTeamMemberJoyrideTours");
    // if (!hasSeenAddTeamMemberTour) {
    //   this.shouldRunTour = true;
    //   // Add delay to ensure DOM is ready
    //   this.tourTimeout = setTimeout(() => {
    //     this.setState({ toolTipAddTeamMemberRun: true });
    //   }, 1000);
    // }

    this._isMounted = true;
  }

  componentWillUnmount() {
    // Clean up MQTT subscription
    if (this.listenerParams && this.mqttClient) {
      this.mqttClient.removeListener('message', this.listenerParams.handler);
      this.mqttClient.unsubscribe(this.listenerParams.topic);
    }
    // Clear timeout to prevent memory leak
    if (this.tourTimeout) {
      clearTimeout(this.tourTimeout);
    }
    this._isMounted = false;
  }

  handleTourEnd = (data) => {
    if ((data.status === "finished" || data.status === "skipped")) {
      sessionStorage.setItem("hasSeenAddTeamMemberJoyrideTours", "true");
      this.setState({ toolTipAddTeamMemberRun: false });
      this.shouldRunTour = false;
    }
  };


  addStep = (newStep) => {
    this.setState((prevState) => {
      // ✅ Prevent duplicates
      const alreadyExists = prevState.addTeamMemberSteps.some(step => step.target === newStep.target);
      if (alreadyExists) {
        return null; // Skip re-render
      }

      const orderedSteps = [...prevState.addTeamMemberSteps, newStep];

      // Sort steps if needed
      orderedSteps.sort((a, b) => {
        const order = {
          "[data-id='Deefeature1']": 1,
          "[data-id='Deefeature27']": 1,
          "[data-id='Deefeature2']": 2,
        };
        return (order[a.target] || 99) - (order[b.target] || 99);
      });

      return { addTeamMemberSteps: orderedSteps };
    });
  };



  componentDidUpdate(prevProps, prevState) {
    const { loadChannelsToPostDispatch, locationId, showingToast, removeShowingToastDispatch, clearDateRangeResetFlagDispatch, shifts, rangeStart, rangeEnd, allUsers, locationData, plans, changeDateRangeSlice, unregisteredUsers, needReset } = this.props;

    if (prevProps.locationData !== locationData) {

      if (plans && plans.length > 0) {
        if (locationData && locationData.plan_id) {
          const cplan = plans.find(plan => plan.id === locationData.plan_id);
          this.setState({ planName: cplan.name });
        }
      }

      if (!this.apiCalled && locationData !== null) {
        var start = startOfLocationFiscalWeek(locationData.fiscal_day);
        var end = endOfLocationFiscalWeek(locationData.fiscal_day);

        if (rangeStart !== null && rangeEnd !== null) {
          //Read cached values if fiscal day not updated

          if (needReset == false) {
            start = rangeStart.clone();
            end = rangeEnd.clone();
          }
        }

        console.log('DidMount - New Date Range: ' + start.format("MMM Do YY") + '-' + end.format("MMM Do YY"));

        this.pageIndex = 1;
        this.makeLoadShiftsCall(start, end, this.pageIndex, 'Initial Load');
        changeDateRangeSlice(start, end);
        loadChannelsToPostDispatch(locationId);
      }

    } else if (prevProps.rangeStart !== rangeStart) {
      if (this.apiCalled) {
        this.pageIndex = 1;
        this.makeLoadShiftsCall(rangeStart, rangeEnd, this.pageIndex, 'Week Range Change');
      }
    } else if (prevProps.shifts !== shifts) {
      this.apiCalled = true;
      clearDateRangeResetFlagDispatch();

      if (prevProps.shifts && shifts) {
        if (shifts.length - prevProps.shifts.length === SHIFTS_PER_PAGE) {
          this.makeLoadShiftsCall(rangeStart, rangeEnd, this.pageIndex, 'Got More Shifts');
        }
      }
    }

    if (showingToast === true) {
      setTimeout(() => {
        removeShowingToastDispatch();
      }, 2000);
    }
  }

  makeLoadShiftsCall(rangeStart, rangeEnd, eventPrefix) {
    const { getShiftsInDateRange } = this.props;
    console.log(eventPrefix + '- Load Page:' + this.pageIndex + ' @ ' + rangeStart.format("MMM Do YYYY") + '-' + rangeEnd.format("MMM Do YYYY"));
    getShiftsInDateRange(rangeStart, rangeEnd, this.pageIndex, SHIFTS_PER_PAGE, true);
    this.pageIndex += 1;
  }

  handleAddTeamMemberClick = (e) => {
    this.setState({ showAddUnregUserModal: true });
  }

  handleCloseAddTeamModal = (e) => {
    this.setState({ showAddUnregUserModal: false });
  }

  handleCloseInviteModal = (e) => {
    this.setState({ showSendEmailModal: false });
  }

  handleShowSMSInviteModal = (user) => {
    this.setState({ showSendEmailModal: true });
    this.unregisteredUserToInvite = user;
  }

  handleDepartmentSelect = (e) => {
    console.log('Dep Selected: ' + e);
    this.setState({ selectedDepartment: e, shiftBeingPasted: null, isShowingPastingSnackBar: false });
  }

  handleGroupSelect = (e) => {
    console.log('Group Selected: ', e);
    this.setState({ selectedGroup: e, shiftBeingPasted: null, isShowingPastingSnackBar: false });
  }

  handleSkillSelect = (e) => {
    console.log('Skill Selected: ', e);
    this.setState({ selectedSkill: e, shiftBeingPasted: null, isShowingPastingSnackBar: false });
  }

  notifySearchTermChanged = (e) => {
    console.log('Search: ' + e);
    this.setState({ searchTerm: e, shiftBeingPasted: null, isShowingPastingSnackBar: false });
  }

  notifyHeaderOfShiftPasting = (isPasting, shift) => {
    this.setState({ isShowingPastingSnackBar: isPasting, shiftBeingPasted: shift });
  }

  // Handle mouse enter event for each cell
  handleTooltipShow = (e, content) => {
    const { tooltip } = this.state;

    const rect = e.target.getBoundingClientRect();

    if (tooltip.visible == false) {
      this.setState({
        tooltip: {
          visible: true,
          content: content,
          position: {
            top: rect.top + window.scrollY + 10,  // Position above the cell
            left: rect.left + window.scrollX + rect.width / 2 - 100, // Centered horizontally
          }
        }
      });
    }
  };

  // Handle mouse leave event from each cell
  handleTooltipHide = () => {
    const { tooltip } = this.state;

    if (tooltip.visible == true) {
      this.setState({
        tooltip: {
          ...this.state.tooltip,
          visible: false
        }
      });
    }

  };

  handleDeleteEntireScheduleModal = () => {
    this.setState({ showDeleteEntireScheduleModal: true });
  }

  handleDeleteDraftsModal = () => {
    this.setState({ showDeleteUnpublishedModal: true });
  }

  cancelDeleteAllModal = () => {
    this.setState({ showDeleteEntireScheduleModal: false });
  }

  cancelDeleteDraftModel = () => {
    this.setState({ showDeleteUnpublishedModal: false });
  }

  handleFinishPasting = () => {
    this.setState({ isShowingPastingSnackBar: false, shiftBeingPasted: null });
  }

  handleTabChange = (tab) => {
    this.setState({ selectedTab: tab });
  }

  render() {
    const { toastMessage, channels, showingToast, deleteAllDraftShiftsDispatch, deleteAllShiftsDispatch, publishDraftShiftsDispatch, shifts, allUsers, associates, managers, locationId, locationData, rangeStart, rangeEnd, startStr, notifyTeamOfPublishDispatch,
      locationSettings, loading, linkUnregisteredUser, changeDateRangeSlice, unregisteredUsers, departments, skills, isVTOConfigured } = this.props;
    const { showDeleteUnpublishedModal, showDeleteEntireScheduleModal, isShowingPastingSnackBar, planName, showSendEmailModal, selectedDepartment, selectedGroup, selectedSkill, searchTerm, shiftBeingPasted, tooltip, addTeamMemberSteps, toolTipAddTeamMemberRun, selectedTab } = this.state;

    // Ensure tour runs if it should
    const finalTourRun = toolTipAddTeamMemberRun || this.shouldRunTour;

    const allUsersWithFields = managers.concat(associates);

    const filteredUsers = utils.filteredUsers(allUsersWithFields, selectedDepartment, selectedGroup, selectedSkill, searchTerm);
    const filteredUnregisteredUsers = utils.filteredUnregisteredUsers(unregisteredUsers, selectedDepartment, selectedGroup, selectedSkill, searchTerm);
    const isSearchOrFilterApplied = utils.isSearchOrFilterApplied(searchTerm, selectedDepartment, selectedGroup, selectedSkill,);

    const weekdays = timeUtil.daysOfTheWeek(locationData)
    const scheduledHoursDictionary = utils.populateTotalScheduledHoursForWeek(shifts, filteredUsers, filteredUnregisteredUsers, service.initializeZeroStatsByWeekday(weekdays))
    const openShiftHoursDictionary = service.populateOpenShiftHoursForWeek(shifts, service.initializeZeroStatsByWeekday(weekdays))
    const vtoHoursDictionary = service.populateVTOHoursForWeek(shifts, service.initializeZeroStatsByWeekday(weekdays))

    const scheduledUserCount = utils.numberOfUsersScheduledForWeek(shifts, filteredUsers, filteredUnregisteredUsers);

    const shouldShowOpenShiftUI = (locationSettings.cfg__shift__post_open_shift == true)


    const shouldShowVTOUI = isVTOConfigured

    const customJoyrideStyles = {
      options: {
        arrowColor: "#2C2C2E", // Background color of the tooltip
        backgroundColor: "#2C2C2E", // Tooltip background color (dark theme)
        overlayColor: "rgba(0, 0, 0, 0.4)", // Slightly dark overlay
        primaryColor: "#2C2C2E", // Highlight color
        textColor: "#ffffff", // White text
        width: 400, // Width of tooltip
        zIndex: 1000,
      },
      tooltip: {
        borderRadius: "12px",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)", // Smooth shadow
        padding: "20px",
      },
      tooltipContainer: {
        lineHeight: 1.4,
        textAlign: 'left',
      },
      tooltipTitle: {
        color: "#FFFFFF",
        fontFamily: "'AvertaSemiBold', sans-serif", // Custom font
        fontSize: "24px",
        letterSpacing: "-0.49px",
        paddingLeft: "0px", // Removes unwanted padding
        textAlign: "left", // Aligns text to left
      },
      tooltipContent: {
        color: "#FFFFFF",
        fontFamily: "'AvertaSemiBold', sans-serif", // Custom font
        fontSize: "16px",
        letterSpacing: "-0.4px",
        paddingLeft: "0px", // Removes unwanted padding
        textAlign: "left", // Aligns text to left
      },
      tooltipFooter: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      },
      buttonClose: {
        color: "#FFFFFF",
        fontSize: "18px",
      },
      buttonNext: {
        backgroundColor: "#FFFFFF",
        color: "#000000",
        fontSize: "14px",
        fontWeight: "600",
        borderRadius: "8px",
        padding: "8px 16px",
      },
      buttonBack: {
        color: "#D1D1D1",
        fontSize: "14px",
        fontWeight: "500",
      },
    };

    return (
      <div className="schedule-calendar__wrap">
        {/* CSS for pulse animation */}
        <style>{pulseAnimationCSS}</style>

        <ScheduleHeaderComponent
          shifts={shifts}
          allUsers={allUsersWithFields}
          allUnregisteredUsers={unregisteredUsers}
          rangeStart={rangeStart}
          rangeEnd={rangeEnd}
          startStr={startStr}
          changeDateRangeSlice={changeDateRangeSlice}
          notifyTeamOfPublishDispatch={notifyTeamOfPublishDispatch}
          publishDraftShiftsDispatch={publishDraftShiftsDispatch}
          locationId={locationId}
          locationData={locationData}
          locationSettings={locationSettings}
          exportableData={dataExport.exportableData(shifts, filteredUsers, filteredUnregisteredUsers, rangeStart, rangeEnd)}
          tableFormatData={dataExport.tableFormatData(shifts, filteredUsers, filteredUnregisteredUsers, rangeStart, rangeEnd)}
          departments={departments}
          channels={channels}
          skills={skills}
          handleDepartmentSelect={this.handleDepartmentSelect}
          handleGroupSelect={this.handleGroupSelect}
          handleSkillSelect={this.handleSkillSelect}
          notifySearchTermChanged={this.notifySearchTermChanged}
          isShowingPastingSnackBar={isShowingPastingSnackBar}
          shiftBeingPasted={shiftBeingPasted}
          handleDeleteDraftsModal={this.handleDeleteDraftsModal}
          handleDeleteEntireScheduleModal={this.handleDeleteEntireScheduleModal}
          notifyHeaderOfShiftPasting={this.handleFinishPasting}
          scheduledResult={scheduledHoursDictionary}
          openShiftResult={openShiftHoursDictionary}
          vtoResult={vtoHoursDictionary}
          scheduledUserCount={scheduledUserCount}
          shouldShowOpenShiftUI={shouldShowOpenShiftUI}
          shouldShowVTOUI={shouldShowVTOUI}
          isPublishing={this.props.isPublishing}
          getShiftsInDateRange={this.props.getShiftsInDateRange}
        // addStep={this.addStep}
        />
        <TableComponent
          shifts={shifts}
          allUsers={filteredUsers}
          rangeStart={rangeStart}
          rangeEnd={rangeEnd}
          locationId={locationId}
          locationSettings={locationSettings}
          locationData={locationData}
          loading={loading}
          linkUnregisteredUser={linkUnregisteredUser}
          unregisteredUsers={filteredUnregisteredUsers}
          handleShowSMSInviteModal={this.handleShowSMSInviteModal}
          shouldShowAddMemberButton={(isSearchOrFilterApplied == false)}
          notifyHeaderOfShiftPasting={this.notifyHeaderOfShiftPasting}
          shiftToCopy={shiftBeingPasted}
          isCopyingShift={isShowingPastingSnackBar}
          handleTooltipShow={this.handleTooltipShow}
          handleTooltipHide={this.handleTooltipHide}
          channels={channels}
          openShiftHoursResult={openShiftHoursDictionary}
          addStep={this.addStep}
          vtoHoursResult={vtoHoursDictionary}
          enableVTO={shouldShowVTOUI}
        />
        {showSendEmailModal === true && <Modal> <InviteWithEmailContainer
          handleCloseInviteModal={this.handleCloseInviteModal}
          userToInvite={this.unregisteredUserToInvite}
          locationId={locationId}
          locationData={locationData}
        /> </Modal>}

        {showDeleteEntireScheduleModal === true && <Modal>
          <ConfirmDeleteAllComponent
            deleteAllShiftsDispatch={deleteAllShiftsDispatch}
            cancelModal={this.cancelDeleteAllModal}
            locationId={locationId}
            shifts={shifts}
            rangeStart={rangeStart}
            rangeEnd={rangeEnd}
          />
        </Modal>}

        {showDeleteUnpublishedModal === true && <Modal>
          <ConfirmDeleteDraftsComponent
            deleteAllDraftShiftsDispatch={deleteAllDraftShiftsDispatch}
            cancelModal={this.cancelDeleteDraftModel}
            locationId={locationId}
            shifts={shifts}
            rangeStart={rangeStart}
            rangeEnd={rangeEnd}
          />
        </Modal>}

        {planName === 'Basic' && <Modal> <UpgradePrompt /> </Modal>}

        <styledConfirm.Overlay display={planName === 'Basic' || showSendEmailModal ? 'block' : 'none'} />

        <table className='calendar-table total-hours-table'>
          <tbody className="total-hours">
            <HoursRowComponent
              locationId={locationId}
              shifts={shifts}
              locationData={locationData}
              filteredUsers={filteredUsers}
              scheduledResult={scheduledHoursDictionary}
              openShiftResult={openShiftHoursDictionary}
              vtoResult={vtoHoursDictionary}
              scheduledUserCount={scheduledUserCount}
              shouldShowOpenShiftUI={shouldShowOpenShiftUI} 
              shouldShowVTOUI={shouldShowVTOUI}
              />
          </tbody>
        </table>

        {tooltip.visible && (
          <div
            className="tooltip"
            style={{
              top: tooltip.position.top,
              left: tooltip.position.left,
              visibility: tooltip.visible ? 'visible' : 'hidden',
              opacity: tooltip.visible ? 1 : 0
            }} >

            <img className='tooltip-caret' src='/icons/caret.svg'></img>
            <div className='tooltip-main'> {tooltip.content} </div>
          </div>
        )}

        {/* <Joyride
          key={`joyride-${finalTourRun}-${addTeamMemberSteps.length}`}
          steps={addTeamMemberSteps}
          run={finalTourRun}
          continuous
          showProgress
          hideBackButton
          callback={this.handleTourEnd}
          styles={customJoyrideStyles}
        /> */}

        {isShowingPastingSnackBar == true && <FinishPastingCopmonent shiftBeingPasted={shiftBeingPasted} handleFinishPasting={this.handleFinishPasting} />}
        {showingToast == true && <div className="toast-message"> {toastMessage} </div>}
      </div>
    );
  }
}

export default injectIntl(ScheduleCalendarComponent);
